<header id="header">
    <app-top-header></app-top-header>
    <app-middle-header></app-middle-header>
    <app-navbar></app-navbar>
</header>
